'use client';

const BAR_HEIGHTS = [35, 55, 80, 95, 70, 85, 50];

export function WaveformBars({ active }: { active: boolean }) {
  return (
    <div className="flex items-center gap-[3px]" style={{ height: '52px' }}>
      {BAR_HEIGHTS.map((h, i) => (
        <div
          key={i}
          className="w-[3px] rounded-sm"
          style={{
            height: `${h}%`,
            background: 'rgba(255, 210, 150, 0.85)',
            animation: active
              ? `bar-wave 0.5s ease-in-out ${i * 0.07}s infinite alternate`
              : `bar-idle 2.5s ease-in-out ${i * 0.18}s infinite alternate`,
          }}
        />
      ))}
    </div>
  );
}
